import { ScreensList } from '@shared-core/navigation/screens-list'
import { SCREENS_PATHS, type ScreenRouteKey } from '@shared-core/navigation/screens-paths'

export type AppRouteKey = keyof typeof SCREENS_PATHS
export type AppRoutePath = (typeof SCREENS_PATHS)[AppRouteKey]

// Экраны, доступные без авторизации (зеркало logout-стека мобилы). Всё остальное — приватное.
export const PUBLIC_SCREEN_KEYS: ReadonlySet<ScreenRouteKey> = new Set<ScreenRouteKey>([
  ScreensList.HOME_START,
  ScreensList.ENTRY_LOADING,
  ScreensList.ENTRY_PHONE,
  ScreensList.ENTRY_OTP,
])

export function isPublicScreen(key: ScreenRouteKey): boolean {
  return PUBLIC_SCREEN_KEYS.has(key)
}

// Вход и привязка используют одни экраны при разном состоянии сессии.
export function isPhoneScreen(key: ScreenRouteKey): boolean {
  return key === ScreensList.ENTRY_PHONE || key === ScreensList.ENTRY_OTP
}

// Все ключи реестра (стабильный список для генерации роутов).
export const APP_ROUTE_KEYS = Object.keys(SCREENS_PATHS) as ScreenRouteKey[]
